import React from "react";
import moment from "moment";

export const isSameValue = (a, b) => String(a) === String(b);

export const toArray = (value) => {
  if (value === undefined || value === null) return [];
  return Array.isArray(value) ? value : [value];
};

export const getNodeText = (node) => {
  if (node === undefined || node === null) return "";
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(getNodeText).join("");
  if (React.isValidElement(node)) return getNodeText(node.props?.children);
  return String(node);
};

export const formatMomentValue = (value, format) => {
  if (!value) return "";
  if (moment.isMoment(value)) return value.format(format);
  const m = moment(value);
  return m.isValid() ? m.format(format) : "";
};

export const normalizeMoment = (value) => {
  if (!value) return null;
  if (moment.isMoment(value)) return value;
  const next = moment(value);
  return next.isValid() ? next : null;
};

export const getPickerMode = (picker) => {
  if (picker === "month") return "month";
  if (picker === "year") return "year";
  return "date";
};
